var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIgnoreCardCarouselDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icIgnoreCardCarouselDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.2626361,26.0667891 L50.8500856,7.47931781 C52.5610826,5.76831876 52.5610826,2.99424834 50.8500856,1.28349407 C49.1390885,-0.427504985 46.3652661,-0.427504985 44.6542691,1.28349407 L26.0665749,19.8712101 L7.47888067,1.28324929 C5.76788363,-0.427749763 2.99406124,-0.427749763 1.2830642,1.28324929 C-0.427688066,2.99424834 -0.427688066,5.76831876 1.2830642,7.47907304 L19.8707584,26.0665443 L1.2830642,44.6542603 C-0.427688066,46.3652593 -0.427688066,49.1393298 1.2830642,50.850084 C2.99406124,52.5610831 5.76788363,52.5610831 7.47888067,50.850084 L26.0665749,32.262368 L44.6542691,50.850084 C46.3650213,52.5610831 49.1390885,52.5610831 50.8500856,50.850084 C52.5610826,49.139085 52.5610826,46.3652593 50.8500856,44.6542603 L32.2626361,26.0667891 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icIgnoreCardCarouselDsk",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIgnoreCardCarouselDsk);
export default __webpack_public_path__ + "static/media/icIgnoreCardCarouselDsk.5cc553751d5c6c67ef99c5e71e191e5f.svg";
export { ForwardRef as ReactComponent };